import React, { FC } from 'react';
// import image from '@/public/images/faq/faq1.webp';
// import Image from 'next/image';
import { Icons } from '@/components/icons';

interface IProps {
  items: { title: string; description: string };
}

export const Faq: FC<IProps> = () => {
  return (
    <div>
      {/*  <div className=" mb-10 flex justify-center">
        <Image src={image} alt="faq" />
      </div> */}
      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            What types of services does Tytum offer?
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="mb-2 text-left">
            We offer a wide range of services, including:
          </p>
          <ul className="list-disc">
            <li className="text-left">Heating and Air Conditioning Services</li>
            <li className="text-left">Electrical Services</li>
            <li className="text-left">Plumbing Services</li>
            <li className="text-left">Remodeling Services</li>
            <li className="text-left">New Construction Services</li>
            <li className="text-left">Real Estate Services</li>
          </ul>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            Does Tytum offer emergency services?
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="text-left ">
            Yes, Tytum offers 24/7 emergency services for both HVAC and plumbing
            issues, ensuring fast and reliable assistance whenever you need it.
          </p>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            What areas does Tytum serve?
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="text-left ">
            We provide services throughout the Greater San Diego Area, including
            East County, Central San Diego, North County, and South Bay.
          </p>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            What heating and air conditioning services does Tytum offer?
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="mb-2 text-left">
            We offer a range of heating services, including:
          </p>
          <ul className="list-disc">
            <li className="text-left">Furnace Repair and Maintenance</li>
            <li className="text-left">
              Heating System Installation and Replacement
            </li>
            <li className="text-left">Heat Pump Services</li>
            <li className="text-left">Ductless Heating Systems</li>
            <li className="text-left">
              Air Conditioning Repair and Maintenance
            </li>
            <li className="text-left">
              Air Conditioning Installation and Replacement
            </li>

            <li className="text-left">Central Air Conditioning Systems</li>
            <li className="text-left">Ductless Air Conditioning Systems</li>
            <li className="text-left">Energy-Efficient AC Upgrades</li>
          </ul>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            Does Tytum provide maintenance plans?{' '}
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="text-left ">
            Yes, Tytum offers seasonal maintenance plans for HVAC systems,
            electrical systems, and plumbing. These plans are designed to keep
            your home systems running efficiently year-round.
          </p>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            How can Tytum help improve my home&apos;s energy efficiency?{' '}
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="mb-2 text-left">
            Tytum offers energy efficiency consulting services such as:
          </p>
          <ul className="list-disc">
            <li className="text-left">Home Energy Audits</li>
            <li className="text-left">HVAC System Efficiency Upgrades</li>
            <li className="text-left">Recommendations for Energy Savings</li>
          </ul>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            Why should I choose Tytum for my heating and air conditioning needs?{' '}
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="text-left ">
            Tytum is committed to providing top-quality services with a focus on
            customer satisfaction. We offer certified technicians, transparent
            pricing, and personalized service. As a locally owned company, we
            are deeply committed to serving the San Diego community.
          </p>
        </div>
      </article>

      <article className="mb-6">
        {' '}
        <h4 className="mb-4 flex items-center gap-6">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            Can Tytum help with thermostat installation and upgrades?{' '}
          </span>
        </h4>
        <div className="pl-14">
          {' '}
          <p className="text-left ">
            Absolutely! We install smart thermostats, provide thermostat repair
            and replacement services, and offer energy-efficient thermostat
            solutions.{' '}
          </p>
        </div>
      </article>
    </div>
  );
};
